import React, { useState } from 'react';
import {
  Rating,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import styles from './styles';

const Contact = function Contact() {
    const [rating, setRating] =useState(2.5);
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleClose= () =>setOpen(false);
    const handleSubmit =() => {
      console.log("Note: "+rating);
    handleClose();
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Le restaurant Antinea</h1>
      <p>Ici info de contact et Géolocalisation + saisie de l'avis</p>
      <p>
        Type de restauration : Brasserie, pizzeria
        <br />
        Accessible aux personnes à mobilité réduite
        <br />
        WIFI disponible
        <br />
        Modes de paiement : CB, Izly
      </p>
      <h2>Horaires</h2>
      <p>11h30-13h45</p>
      <h2>Accès</h2>
      <p>
        15 rue Vaux de Foletier 17000 LA ROCHELLE
        <br />
        Téléphone : 05.46.44.18.57
      </p>
      <h2>Avis</h2>
      <p>Note globale : 4.2 ⭐</p>
      <div style={{ marginTop: '20px', display: 'flex', justifyContent:'center', margin: '1rem'}}>
        <Button variant='outlined' onClick={handleClickOpen} style={{ color: "black", backgroundColor: "orange",  }}>
          Votez !
        </Button>
      </div>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Votre avis nous intéresse !</DialogTitle>
        <DialogContent>
          <Rating
            name='popup-rating'
            value={rating}
            precision={0.5}
            onChange={(event, newValue) => setRating(newValue)}
          /></DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          <Button onClick={handleSubmit}>Valider</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Contact;